
import EditInput from '@/components/edit/EditInput';

export default {
    extends: EditInput,

    computed: {
        refName() {
            return `${this.fieldPath}Ref`;
        },
        refDef() {
            return $.getExpandedRefDef(this.collName, this.withPrefix(this.refName.replace(/\[\d+\]/, '')));
        },
        modelWithRef: {
            get() {
                return this.model;
            },
            set(value) {
                this.model = value;

                $.set(this.editItem, this.refName, value && value.id);
            },
        },
    },
};
